<template>
  <div></div>
</template>
<script>
import { onMounted, watch } from "vue";
import { useStore } from "vuex";
export default {
  props: ["unidadeId"],
  emits: ["enviarCatalogoEspecifico"],
  setup(props, { emit }) {
    const store = useStore();

    const selecionarCatalogoEspecifico = async () => {
      if (props.unidadeId === "" || props.unidadeId === undefined) {
        return;
      }
      try {
        const response = await store.dispatch("ferramentaria/listarCatalogo", {
          unidadeId: props.unidadeId,
          page: 1,
          perPage: 10,
        });
        if (response.response.data.resultado?.dados.length == 0) {
          return;
        }
        emit(
          "enviarCatalogoEspecifico",
          response.response.data.resultado?.dados[0]?.catalogoUuid
        );
      } catch (error) {
        console.log(error);
      }
    };

    watch(
      () => props.unidadeId,
      () => {
        selecionarCatalogoEspecifico();
      }
    );

    onMounted(() => {
      selecionarCatalogoEspecifico();
    });

    return { selecionarCatalogoEspecifico };
  },
};
</script>
